import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // private loading = false;
  initialValue: boolean = true;

  _loadingSource :BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.initialValue);
  // castLoading: Observable<boolean> = this.loading.asObservable()
  constructor() { }


  toggleLoading(value: boolean) {
   if (value !== this.loading) {
     this._loadingSource.next(value)
   }
  }
  getLoading(): Observable<boolean> {
    return this._loadingSource.asObservable();
  }

  get loading(): boolean {
    return this._loadingSource.getValue();
  }

  // get isLoading(): boolean {
  //   return this.loading;
  // }
}
